var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-print-white';
                    var viewUrl = 'gfx/sprite.svg#view-icon-print-white';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 23 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };